export default {
  title: '{level} erstellen',
  helperText: 'Hier können neue Anlagen angelegt werden, sofern die Lizenz dies erlaubt.',
};
